import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

import { reducers, metaReducers } from './store/reducers';
import { ObstaclesEffects } from './store/effects/obstacles.effects';
import { ClassificationEffects } from './store/effects/classification.effects';
import { LeaderboardEffects } from './store/effects/leaderboard.effects';
// import { BarriersEffects } from './store/effects/barriers.effects';

import { CoreoService, ApiService, MapService } from './services';

@NgModule({
  imports: [
    StoreModule.forRoot(reducers, { metaReducers }),
    EffectsModule.forRoot([
      ObstaclesEffects,
      ClassificationEffects,
      LeaderboardEffects
      // BarriersEffects
    ])
  ],
  providers: [
    CoreoService,
    ApiService,
    MapService,
    ObstaclesEffects,
    ClassificationEffects,
    LeaderboardEffects,
    // BarriersEffects
  ]
})
export class CoreModule {

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/core/core.module.ts